import { GoogleOAuthProvider, GoogleLogin } from "@react-oauth/google";
import { useSessionContext } from '../../Context/SessionContext';
import { getTokenOrDefault } from '../../Helpers/Storage';
import { tryRefresh, fetchProfile } from "../../Security/actions";

interface GoogleSignInProps {
  mode: 'login' | 'register';
}

const GoogleSignIn: React.FC<GoogleSignInProps> = ({ mode }) => {
  const apiEndpoint = process.env.REACT_APP_API_ENDPOINT;
  const clientID= process.env.REACT_APP_CLIENT_ID|| "";
  const { setSession } = useSessionContext();
  

  return (
    <GoogleOAuthProvider clientId={clientID}>
       <div className="google-button-wrapper">
      <GoogleLogin
        onSuccess={(credentialResponse) => {
          const credential = credentialResponse.credential;
          
          fetch(`${apiEndpoint}/auth/google/callback`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ token: credential }),
            credentials: "include",
          })
            .then((res) => res.json())
            .then(async(data) => {
              if (data.status_code === 200 && data.token) {
                console.log("login success")
            
                const token = data.token;
            
                const refresh = await tryRefresh(token);

                const profile = await fetchProfile(token);

                if (profile.is_success) {
                  setSession(profile.data);
                }

                window.location.href = "/";
              } else {
                window.location.href = "/sec/log-in";
              }
            })
            .catch((err) => {
              console.error("Auth failed", err);
            });
        }}
        onError={() => {
          console.error("Login Failed");
        }}
        text={mode === 'login' ? "continue_with" : "signup_with"}
        useOneTap={false}
        width="100%"
        theme="outline"
        size="large"
        containerProps={{
          style: { width: '100%', justifyContent: 'center', display: 'flex', flexDirection: 'column' }
        }}
      />
      </div>
    </GoogleOAuthProvider>
  );
};

export default GoogleSignIn;
